import axios from 'lib/axios'
import { USER_DETAIL_PROCESS } from '../constants'

export const fetchGetUserProcessAction = async (userId: number, companyId: number) => {
  try {
    const response = await axios.get(`${USER_DETAIL_PROCESS}${userId}`, {
      params: companyId ? { company_id: companyId } : undefined,
    })
    return response.data.data
  } catch (error) {
    throw new Error('Error fetching actions')
  }
}
